import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "buildingblocktypes"
    }}>{`BuildingBlockTypes`}</h1>
    <p>{`Cross reference building block types.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CUSTOM_STRING_BUILDING_BLOCK`}</strong>{` = 1650615155`}</p>
      <p parentName="blockquote">{`Custom string building block type.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FILE_NAME_BUILDING_BLOCK`}</strong>{` = 1650615918`}</p>
      <p parentName="blockquote">{`File name building block type.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CHAPTER_NUMBER_BUILDING_BLOCK`}</strong>{` = 1650615150`}</p>
      <p parentName="blockquote">{`Chapter number building block type.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PAGE_NUMBER_BUILDING_BLOCK`}</strong>{` = 1650618478`}</p>
      <p parentName="blockquote">{`Page number building block type.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FULL_PARAGRAPH_BUILDING_BLOCK`}</strong>{` = 1650615920`}</p>
      <p parentName="blockquote">{`Full paragraph building block type.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PARAGRAPH_NUMBER_BUILDING_BLOCK`}</strong>{` = 1651533678`}</p>
      <p parentName="blockquote">{`Paragraph number building block type.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PARAGRAPH_TEXT_BUILDING_BLOCK`}</strong>{` = 1650618484`}</p>
      <p parentName="blockquote">{`Paragraph text building block type.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BOOKMARK_NAME_BUILDING_BLOCK`}</strong>{` = 1650614894`}</p>
      <p parentName="blockquote">{`Bookmark name building block type.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      